/*=========================================================================================
  File Name: vue-tailwind.config.js
  Description: Theme configuration for VueTailwind 2.0
  ----------------------------------------------------------------------------------------
  Documentation: https://www.vue-tailwind.com/docs/theming
==========================================================================================*/

import {
  TDropdown,
  TSelect,
  TToggle,
  TTextarea,
  TCheckbox,
  TButton
} from 'vue-tailwind/dist/components'

const settings = {
  't-dropdown': {
    component: TDropdown,
    props: {
      fixedClasses: {
        button:
          'flex items-center text-white block transition duration-100 ease-in-out border border-transparent rounded shadow-sm',
        wrapper: 'inline-flex flex-col',
        dropdownWrapper: 'relative z-10',
        dropdown: 'origin-top-left absolute left-0 w-56 rounded shadow mt-1',
        enterClass: '',
        enterActiveClass:
          'transition ease-out duration-100 transform opacity-0 scale-95',
        enterToClass: 'transform opacity-100 scale-100',
        leaveClass: 'transition ease-in transform opacity-100 scale-100',
        leaveActiveClass: '',
        leaveToClass: 'transform opacity-0 scale-95 duration-75'
      },
      classes: {
        button: 'bg-transparent',
        dropdown: 'bg-white'
      }
    }
  },
  't-select': {
    component: TSelect,
    props: {
      fixedClasses:
        'block w-full px-2 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:outline-none',
      classes:
        'text-black placeholder-gray-400 bg-white border-gray-300 max-w-350px'
    }
  },
  't-toggle': {
    component: TToggle,
    props: {
      fixedClasses: {
        wrapper:
          'relative inline-flex flex-shrink-0 cursor-pointer transition-colors ease-in-out duration-200',
        wrapperChecked:
          'relative inline-flex flex-shrink-0 cursor-pointer transition-colors ease-in-out duration-200  border-2 border-transparent focus:outline-none',
        button:
          'inline-block absolute transform translate-x-0 transition ease-in-out duration-200',
        buttonChecked:
          'inline-block absolute transform translate-x-full transition ease-in-out duration-200',
        checkedPlaceholder: 'inline-block',
        uncheckedPlaceholder: 'inline-block'
      },
      classes: {
        wrapper:
          'bg-orange-400 rounded-full border-2 border-transparent focus:outline-none',
        wrapperChecked: 'bg-green-400 rounded-full',
        button: 'h-5 w-5 rounded-full bg-white shadow',
        buttonChecked: 'h-5 w-5 rounded-full bg-white shadow',
        checkedPlaceholder: 'rounded-full w-5 h-5',
        uncheckedPlaceholder: 'rounded-full w-5 h-5'
      }
    }
  },
  't-textarea': {
    component: TTextarea,
    props: {
      fixedClasses:
        'block w-full px-3 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
      classes:
        'text-black placeholder-gray-400 bg-white border-gray-300 focus:border-blue-500 '
    }
  },
  't-checkbox': {
    component: TCheckbox,
    props: {
      fixedClasses:
        'transition duration-100 ease-in-out rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0',
      classes: 'text-primary border-gray-300 '
    }
  },
  't-button': {
    component: TButton,
    props: {
      fixedClasses:
        'block w-full py-2 transition duration-100 ease-in-out focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
      classes:
        'text-white bg-primary border border-transparent shadow-sm rounded hover:bg-blue-600 max-w-350px',
      variants: {
        error:
          'text-white bg-red-500 border border-transparent rounded shadow-sm hover:bg-red-600',
        success:
          'text-white bg-green-400 border border-transparent rounded shadow-sm',
        link: 'text-blue-500 underline hover:text-blue-600'
      }
    }
  }
}

export default settings
